import _jsx from "@babel/runtime/helpers/jsx";
var _Glyphicon;
import React from 'react';
import PropTypes from 'prop-types';
import { Button, Glyphicon, IconButton, Chip } from 'reaxl';

/**
 * Renders the button for chat with different styling based on UI context.
 * @param {object} props - The component props
 * @param {string} props.className - CSS class name to add to the button
 * @param {string} props.label - Custom label text for the button
 * @param {function} props.onChatClick - Callback function for clicking the chat button
 * @param {string} props.uiContext - UI context to render different styles of button ('iconButton', 'iconButtonStacked', 'button', 'link')
 * @param {boolean} props.isDealerNameRelocation - Flag to determine if dealer name relocation is enabled
 * @returns {JSX.Element} The rendered chat button component
 */
function OwnerChatCta(_ref) {
  let {
    className,
    label,
    onChatClick,
    uiContext,
    isDealerNameRelocation,
    ...props
  } = _ref;
  if (uiContext === 'snapshot') {
    return /*#__PURE__*/_jsx(IconButton, {
      label: label || (isDealerNameRelocation ? 'Chat' : 'Chat with Us'),
      glyph: "commenting-o",
      onClick: onChatClick,
      glyphClassName: "margin-right-3 padding-0",
      monochrome: true,
      size: "medium",
      muted: true
    });
  }
  if (uiContext === 'iconButton') {
    return /*#__PURE__*/_jsx(IconButton, {
      label: label || (isDealerNameRelocation ? 'Chat' : 'Chat with Us'),
      glyph: "commenting-o",
      onClick: onChatClick
    });
  }
  if (uiContext === 'iconButtonStacked') {
    return /*#__PURE__*/_jsx(IconButton, {
      glyph: "commenting-o",
      label: label || 'Chat',
      layout: "stacked",
      onClick: onChatClick,
      size: "large"
    });
  }
  if (uiContext === 'chip') {
    return /*#__PURE__*/React.createElement(Chip, Object.assign({}, props, {
      className: className,
      uiContext: "inquiry",
      onClick: onChatClick,
      label: label || 'Chat with Seller'
    }));
  }
  const bsStyle = {
    button: 'secondary',
    link: 'link'
  }[uiContext];
  return /*#__PURE__*/React.createElement(Button, Object.assign({}, props, {
    className: className,
    block: uiContext === 'button',
    bsStyle: bsStyle,
    onClick: onChatClick
  }), _Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
    glyph: "commenting-o",
    className: "margin-right-2",
    "aria-hidden": "true"
  })), label || 'Chat with Dealer');
}
export default OwnerChatCta;